import { render, staticRenderFns } from "./fqYou.vue?vue&type=template&id=99592f84&"
import script from "./fqYou.vue?vue&type=script&lang=js&"
export * from "./fqYou.vue?vue&type=script&lang=js&"
import style0 from "./fqYou.vue?vue&type=style&index=0&id=99592f84&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports